// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.magazine-widget h2 {
    font-size: 1.2em;
}

.magazine-widget nav {
    margin-bottom: 30px;
    display: inline;
    cursor: pointer;
}

.magazine-widget nav img {
    max-width: 300px;
}

.magazine-widget nav button {
    float: right;
    display: none;
}

.magazine-category {
    font-size: 18px;
    font-family: franklingothic-book, serif;
    letter-spacing: 2px;
    padding: 5px 0 5px;
    text-transform: uppercase;
    color: #c2182a;
}

.magazine-image {
    width: 100%;
    max-width: 100%;
    max-height: 40vw;
    object-fit: cover;
    height: auto;
    min-height: 7vw;
}

.magazine-article {
    margin-bottom: 40px;
}

.magazine-article:hover {
    margin-top: -3px;
    margin-bottom: 43px;
}

.magazine-link {
    overflow: visible !important;
    height: fit-content;
    display: block;
    text-decoration: none !important;
}

.magazine-teaser {
    color: rgb(86, 87, 89);
}

@media only screen and (min-width: 1000px) {
    .magazine-multi {
        display: grid;
        grid-auto-flow: row;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        clear: both;
    }

    .magazine-article {
        margin-bottom: 20px;
    }

    .magazine-article:hover {
        margin-bottom: 23px;
    }

    .magazine-multi .magazine-image {
        height: 230px;
    }

    .magazine-widget nav button {
        display: inline-block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/magazine-widget.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,qCAAqC;QACrC,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".magazine-widget h2 {\n    font-size: 1.2em;\n}\n\n.magazine-widget nav {\n    margin-bottom: 30px;\n    display: inline;\n    cursor: pointer;\n}\n\n.magazine-widget nav img {\n    max-width: 300px;\n}\n\n.magazine-widget nav button {\n    float: right;\n    display: none;\n}\n\n.magazine-category {\n    font-size: 18px;\n    font-family: franklingothic-book, serif;\n    letter-spacing: 2px;\n    padding: 5px 0 5px;\n    text-transform: uppercase;\n    color: #c2182a;\n}\n\n.magazine-image {\n    width: 100%;\n    max-width: 100%;\n    max-height: 40vw;\n    object-fit: cover;\n    height: auto;\n    min-height: 7vw;\n}\n\n.magazine-article {\n    margin-bottom: 40px;\n}\n\n.magazine-article:hover {\n    margin-top: -3px;\n    margin-bottom: 43px;\n}\n\n.magazine-link {\n    overflow: visible !important;\n    height: fit-content;\n    display: block;\n    text-decoration: none !important;\n}\n\n.magazine-teaser {\n    color: rgb(86, 87, 89);\n}\n\n@media only screen and (min-width: 1000px) {\n    .magazine-multi {\n        display: grid;\n        grid-auto-flow: row;\n        grid-template-columns: repeat(4, 1fr);\n        grid-gap: 20px;\n        clear: both;\n    }\n\n    .magazine-article {\n        margin-bottom: 20px;\n    }\n\n    .magazine-article:hover {\n        margin-bottom: 23px;\n    }\n\n    .magazine-multi .magazine-image {\n        height: 230px;\n    }\n\n    .magazine-widget nav button {\n        display: inline-block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
